// ============================================================
// THE ORIGIN CLASS-WORDS - what a combatant is, in the Codex's words.
//
// A leaf, so anything may name a class without importing the threat
// assessment that decides who belongs to which (`threatAssessment.ts`
// holds the rules, in this order; a test keeps the two in step).
// MORTALIS is the class of whoever is none of the others.
//
// Pure. Zero dependencies.
// ============================================================
export const ORIGIN_CLASSES = [
  'DAEMONICA',
  'XENOS',
  'UMBRA',
  'IMMATERIA',
  'EXANIMA',
  'MALEFICA',
  'MACHINA',
  'ASTARTES',
  'BESTIA',
  'MORTALIS',
] as const;
export type OriginClass = (typeof ORIGIN_CLASSES)[number];
